import styled from "styled-components"
import { AreaChart, Area, XAxis, YAxis, ResponsiveContainer, Tooltip } from "recharts"

const ChartContainer = styled.div`
  width: 100%;
  height: 100%;
`

const StatsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-bottom: 8px;
`

const CurrentValue = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`

const ValueText = styled.div`
  font-size: 24px;
  font-weight: 700;
`

const TimeframeText = styled.div`
  font-size: 12px;
  color: ${(props) => props.theme.secondaryText};
`

const TooltipContainer = styled.div`
  background-color: ${(props) => props.theme.card};
  border: 1px solid ${(props) => props.theme.border};
  border-radius: 4px;
  padding: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
`

const TooltipTitle = styled.div`
  font-size: 12px;
  font-weight: 600;
  margin-bottom: 4px;
`

const TooltipValue = styled.div`
  font-size: 12px;
`

function DominanceChart({ type }) {
  // Mock data for the chart
  const data = {
    btc: [
      { date: "Jan", value: 42 },
      { date: "Feb", value: 43 },
      { date: "Mar", value: 45 },
      { date: "Apr", value: 44 },
      { date: "May", value: 46 },
      { date: "Jun", value: 45 },
      { date: "Jul", value: 48 },
      { date: "Aug", value: 50 },
      { date: "Sep", value: 49 },
      { date: "Oct", value: 51 },
      { date: "Nov", value: 52 },
      { date: "Dec", value: 50 },
    ],
    eth: [
      { date: "Jan", value: 18 },
      { date: "Feb", value: 17 },
      { date: "Mar", value: 16 },
      { date: "Apr", value: 17 },
      { date: "May", value: 18 },
      { date: "Jun", value: 19 },
      { date: "Jul", value: 18 },
      { date: "Aug", value: 17 },
      { date: "Sep", value: 18 },
      { date: "Oct", value: 19 },
      { date: "Nov", value: 20 },
      { date: "Dec", value: 19 },
    ],
    usdt: [
      { date: "Jan", value: 5 },
      { date: "Feb", value: 5.2 },
      { date: "Mar", value: 5.5 },
      { date: "Apr", value: 5.3 },
      { date: "May", value: 5.1 },
      { date: "Jun", value: 5.4 },
      { date: "Jul", value: 5.6 },
      { date: "Aug", value: 5.8 },
      { date: "Sep", value: 5.7 },
      { date: "Oct", value: 5.9 },
      { date: "Nov", value: 6.1 },
      { date: "Dec", value: 6 },
    ],
  }

  const chartColors = {
    btc: "#F7931A",
    eth: "#627EEA",
    usdt: "#26A17B",
  }

  const currentValue = data[type][data[type].length - 1].value

  const CustomTooltip = ({ active, payload, label }) => {
    if (active && payload && payload.length) {
      return (
        <TooltipContainer>
          <TooltipTitle>{label}</TooltipTitle>
          <TooltipValue>{payload[0].value}%</TooltipValue>
        </TooltipContainer>
      )
    }
    return null
  }

  return (
    <ChartContainer>
      <StatsContainer>
        <CurrentValue>
          <ValueText>{currentValue}%</ValueText>
          <TimeframeText>Last 12 months</TimeframeText>
        </CurrentValue>
      </StatsContainer>
      <div style={{ height: "128px" }}>
        <ResponsiveContainer width="100%" height="100%">
          <AreaChart data={data[type]}>
            <defs>
              <linearGradient id={`gradient-${type}`} x1="0" y1="0" x2="0" y2="1">
                <stop offset="5%" stopColor={chartColors[type]} stopOpacity={0.3} />
                <stop offset="95%" stopColor={chartColors[type]} stopOpacity={0} />
              </linearGradient>
            </defs>
            <XAxis dataKey="date" tick={{ fontSize: 10 }} tickLine={false} axisLine={false} />
            <YAxis
              domain={["dataMin - 1", "dataMax + 1"]}
              tick={{ fontSize: 10 }}
              tickLine={false}
              axisLine={false}
              tickFormatter={(value) => `${value}%`}
            />
            <Tooltip content={<CustomTooltip />} />
            <Area
              type="monotone"
              dataKey="value"
              stroke={chartColors[type]}
              strokeWidth={2}
              fill={`url(#gradient-${type})`}
            />
          </AreaChart>
        </ResponsiveContainer>
      </div>
    </ChartContainer>
  )
}

export default DominanceChart

